import React from 'react';
import valueableclients from '../img/clients/our-valueable-clients-banner.jpg';

import bg12 from '../images/background/bg-12.jpg';
import crossline from '../images/background/cross-line2.png';
import clients1 from '../img/clients/1.png';
import clients2 from '../img/clients/2.png';
import clients3 from '../img/clients/3.png';
import clients4 from '../img/clients/4.png';
import clients5 from '../img/clients/5.png';
import clients6 from '../img/clients/6.png';
import clients7 from '../img/clients/7.png';
import clients8 from '../img/clients/8.png';
import clients9 from '../img/clients/9.png';
import clients10 from '../img/clients/10.png';
import clients11 from '../img/clients/11.png';
import clients12 from '../img/clients/12.png';
import clients13 from '../img/clients/13.png';
import clients14 from '../img/clients/14.png';
import clients15 from '../img/clients/15.png';
import clients16 from '../img/clients/16.png';
import clients17 from '../img/clients/17.png';
import clients18 from '../img/clients/18.png';
import clients19 from '../img/clients/19.png';
import clients20 from '../img/clients/20.png';
import clients21 from '../img/clients/21.png';
import clients22 from '../img/clients/22.png';
import clients23 from '../img/clients/23.png';
import clients24 from '../img/clients/24.png';
import clients25 from '../img/clients/25.png';
import clients26 from '../img/clients/26.png';
import clients27 from '../img/clients/27.png';
import clients28 from '../img/clients/28.png';
import clients29 from '../img/clients/29.png';
import clients30 from '../img/clients/30.png';
import clients31 from '../img/clients/31.png';
import clients32 from '../img/clients/32.png';
import clients33 from '../img/clients/33.png';
import clients34 from '../img/clients/34.png';
import clients35 from '../img/clients/35.png';
import clients36 from '../img/clients/36.png';
import clients37 from '../img/clients/37.png';
import clients38 from '../img/clients/38.png';
import clients39 from '../img/clients/39.png';
import clients43 from '../img/clients/43.png';
import clients46 from '../img/clients/46.png';
import clients47 from '../img/clients/47.png';
import clients51 from '../img/clients/51.png';
import clients53 from '../img/clients/53.png';
import clients57 from '../img/clients/57.png';
import clients58 from '../img/clients/58.png';
import clients60 from '../img/clients/60.png';
import clients61 from '../img/clients/61.png';
import clients62 from '../img/clients/62.png';
import clients63 from '../img/clients/63.png';
import clients65 from '../img/clients/65.png';
import clients68 from '../img/clients/68.png';
import clients70 from '../img/clients/70.png';
import clients71 from '../img/clients/71.png';
import clients73 from '../img/clients/73.png';
import clients74 from '../img/clients/74.png';
import clients75 from '../img/clients/75.png';
import clients76 from '../img/clients/76.png';
import clients78 from '../img/clients/78.png';
import clients79 from '../img/clients/79.png';
import clients80 from '../img/clients/80.png';
import clients81 from '../img/clients/81.png';
import clients82 from '../img/clients/82.png';
import clients83 from '../img/clients/83.png';
import clients84 from '../img/clients/84.png';
import clients87 from '../img/clients/87.png';
import clients90 from '../img/clients/90.png';
import clients91 from '../img/clients/91.png';
import clients92 from '../img/clients/92.png';
import clients93 from '../img/clients/93.png';
import clients94 from '../img/clients/94.png';
import '../css/ourcustomer.css';
import '../css/testimonials.css';
function Ourcustomers() {
  const testimonials = [
    {
      id: 1,
      name: "SAHIL SAINI",
      company: "JW MARRIOTT CHANDIGARH.",
      description: "We are very happy with your dealing in J W Marriott Chandigarh and services / Product is so much appreciable and Spinoff Team support us fabulous!."
    },
    {
      id: 2,
      name: "Jai Upadhyay",
      company: "GMP TECHNICAL SOLUTION ",
      description: "Clean room LED  Light Fixtures product performance is Good."
    }
  ];
  return (
<div className="page-content">
  {/* INNER PAGE BANNER */}
  <div
    className="sx-bnr-inr overlay-wraper bg-parallax bg-top-center"
    data-stellar-background-ratio="0.5"
    style={{ backgroundImage: `url(${valueableclients})` }} 
  >
    <div className="overlay-main bg-black opacity-07" />
    <div className="container">
      <div className="sx-bnr-inr-entry">
        <div className="banner-title-outer">
          <div className="banner-title-name">
            <h2 className="m-tb0">Our Customers</h2>
           {/* <p>
              Our valuable customers drive our innovation and excellence,
              inspiring us to deliver tailored solutions and exceptional service
              experiences
            </p>*/}
            <p>
              Our mission is always on enhancing  customer satisfaction by innovation and consistent 
              Quality control; thereby ensuring Value for Money . For achieving this objective our R&D and the NPD teams work passionately 
              in a focussed manner.
            </p>
          </div>
        </div>
        
      </div>
    </div>
  </div>
  {/* INNER PAGE BANNER END */}
  {/* OUR CLIENTS */}
  <div
    className="section-full  mobile-page-padding bg-gray  p-t80 p-b50 bg-repeat"
    style={{ backgroundImage: `url(${bg12})` }} 
  >
    <div className="container">
   
    <div className="testimonials-section">
      <h2>What Our Clients Say</h2>
      <div className="testimonials-grid">
        {testimonials.map((client) => (
          <div key={client.id} className="testimonial-card">
            <h3>{client.name}</h3>
            <p className="company-name">{client.company}</p>
            <p className="client-feedback">"{client.description}"</p>
          </div>
        ))}
      </div>
    </div>

      <div className="section-head">
        <div className="sx-separator-outer separator-left">
          <div
            className="sx-separator bg-white bg-moving bg-repeat-x"
            style={{ backgroundImage: `url(${crossline})` }} 
          >
            <h3 className="sep-line-one">Business Associates</h3>
          </div>
        </div>
      </div>
      {/* TITLE END */}
      <div className="section-content">
        <div className="client-grid">
          <div className="row justify-content-center">
            <div className="col-lg-3 col-md-4 col-sm-6 m-b30">
              <p href="javascript:;" className="client-logo-pic">
                <img src={clients1} alt="" />
                <div>
                  <span>All Round</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients2} alt="" />
                <div>
                  <span>Octave</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients3} alt="" />
                <div>
                  <span>Synergy Metals</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients4} alt="" />
                <div>
                  <span>Testing Center</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients5} alt="" />
                <div>
                  <span>SBI</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients6} alt="" />
                <div>
                  <span>NABL</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients7} alt="" />
                <div>
                  <span>GOVT OF PJB</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients8} alt="" />
                <div>
                  <span>HPGCL</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients9} alt="" />
                <div>
                  <span>PP</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients10} alt="" />
                <div>
                  <span>RGNUL</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients11} alt="" />
                <div>
                  <span>CITCO</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients12} alt="" />
                <div>
                  <span>SBI LIFE</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients13} alt="" />
                <div>
                  <span>CHITKARA</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients14} alt="" />
                <div>
                  <span>MCDONALD'S</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients15} alt="" />
                <div>
                  <span>WINSOME</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients16} alt="" />
                <div>
                  <span>MAHINDRA</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients17} alt="" />
                <div>
                  <span>ADLABS</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients18} alt="" />
                <div>
                  <span>ROTARY</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients19} alt="" />
                <div>
                  <span>SAMRAT</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients20} alt="" />
                <div>
                  <span>VODAFONE</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients21} alt="" />
                <div>
                  <span>CGC</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients22} alt="" />
                <div>
                  <span>CBL</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients23} alt="" />
                <div>
                  <span>TYNOR</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients24} alt="" />
                <div>
                  <span>SYSCHEM</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients25} alt="" />
                <div>
                  <span>CHEMEX OIL</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients26} alt="" />
                <div>
                  <span>WALMART</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients27} alt="" />
                <div>
                  <span>PCA</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients28} alt="" />
                <div>
                  <span>CHANDIGARH GOLF CLUB</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients29} alt="" />
                <div>
                  <span>JLPL</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients30} alt="" />
                <div>
                  <span>QUARK CITY</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients31} alt="" />
                <div>
                  <span>JIO</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients32} alt="" />
                <div>
                  <span>ULTRATECH CEMENT</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients33} alt="" />
                <div>
                  <span>ISB</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients34} alt="" />
                <div>
                  <span>ELANTE</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients35} alt="" />
                <div>
                  <span>SHIVALIK</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients36} alt="" />
                <div>
                  <span>EURO KIDS</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients37} alt="" />
                <div>
                  <span>CP67</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients38} alt="" />
                <div>
                  <span>CHANDIGARH UNIVERSITY</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients39} alt="" />
                <div>
                  <span>HAVELI</span>
                </div>
              </p>
            </div>
            {/* <div class="col-lg-3 col-md-4 col-sm-6  m-b30">
                            <a href="javascript:;" class="client-logo-pic">
                            <img src={clients40} alt="" />
                              <div>
                                <span>HAVELI</span>
                              </div>
                            </a>
                          </div> */}
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients43} alt="" />
                <div>
                  <span>CONSORT</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients46} alt="" />
                <div>
                  <span>MOUNT CARMEL SCHOOL</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients47} alt="" />
                <div>
                  <span>JLL</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients51} alt="" />
                <div>
                  <span>RADHEY POLY</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients53} alt="" />
                <div>
                  <span>MICHY'S</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients57} alt="" />
                <div>
                  <span>BIO CLEAN</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients58} alt="" />
                <div>
                  <span>CANBRO</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients60} alt="" />
                <div>
                  <span>MAYA BIO</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients61} alt="" />
                <div>
                  <span>TOREX</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients62} alt="" />
                <div>
                  <span>MOREPEN</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients63} alt="" />
                <div>
                  <span>THEON</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients65} alt="" />
                <div>
                  <span>PANACEA BIO</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients68} alt="" />
                <div>
                  <span>MARC</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients70} alt="" />
                <div>
                  <span>SHAPOORJI</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients71} alt="" />
                <div>
                  <span>SUSHMA</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients73} alt="" />
                <div>
                  <span>JW MARRIOTT</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients74} alt="" />
                <div>
                  <span>TAJ GROUP</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients75} alt="" />
                <div>
                  <span>SAMSON LAB</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients76} alt="" />
                <div>
                  <span>KRBL</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients79} alt="" />
                <div>
                  <span>INNOVA</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients78} alt="" />
                <div>
                  <span>SUNLIFE</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients80} alt="" />
                <div>
                  <span>MDC PHARMA</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients81} alt="" />
                <div>
                  <span>USV</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients82} alt="" />
                <div>
                  <span>GLENMARK</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients83} alt="" />
                <div>
                  <span>ALKEM</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients84} alt="" />
                <div>
                  <span>MACLEODS</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients87} alt="" />
                <div>
                  <span>DEFENCE</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients90} alt="" />
                <div>
                  <span>MINISTRY OF DEF</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients91} alt="" />
                <div>
                  <span>INDIA POST</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients92} alt="" />
                <div>
                  <span>RAILWAY</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients93} alt="" />
                <div>
                  <span>PANJAB DIGI</span>
                </div>
              </p>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6  m-b30">
              <p href="javascript:;" className="client-logo-pic">
              <img src={clients94} alt="" />
                <div>
                  <span>NRI SABHA</span>
                </div>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    
  </div>
  {/* OUR CLIENTS END */}
</div>


  );
}



export default Ourcustomers;
